import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

/**
 * @description base class including button hover text color modifications logic
 */
export abstract class ButtonHoverBorderColorBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].HOVERED_BORDER_COLOR;
  }
}
